import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FlightDocumentPayload,
  FlightLoadControlDocumentationResponse,
} from '../models/flight-document.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FlightDocumentService {
  constructor(private readonly http: HttpClient) {}

  getFlightDocument(
    payload: FlightDocumentPayload
  ): Observable<FlightLoadControlDocumentationResponse> {
    const baseUrl = environment.apiBaseUrl;
    const leg = payload.flightLoadControlDocumentation.datedFlightLeg;

    const carrier = leg.flightNumber.operatingCarrierCode;
    const fullFlightNo = leg.flightNumber.operationalFlightNumber;

    const match = /^(\d+)([A-Za-z]?)$/.exec(fullFlightNo);
    const flightNo = match ? match[1] : fullFlightNo;
    const suffix = match?.[2] || '';

    let params = new HttpParams()
      .set('origin', leg.flightLegOrigin.iataCode)
      .set('departureDateLocal', leg.scheduledDepartureDateTimeLocal)

      .set('documentType', 'DOC')
      .set('documentIdentifier', leg.document.documentType);

    if (suffix) {
      params = params.set('suffix', suffix);
    }

    if (payload?.flightLoadControlDocumentation?.datedFlightLeg?.destination) {
      params = params.set(
        'destination',
        payload.flightLoadControlDocumentation.datedFlightLeg.destination
      );
    }

    return this.http.get<FlightLoadControlDocumentationResponse>(
      `${baseUrl}/flcd/${carrier}/${flightNo}`,
      { params }
    );
  }
}
